// import prompt_mix from '@/mixins/prompt_mix'
// mixins:[prompt_mix],

const prompt_mix = {
  methods: {
    pr_dispatchMessage({ id }) {
      const { hotkeys } = this.$store.getters
      const mobile = this.$store.getters.globals_mobile
      if (id === 'gmf_change' && mobile) {
        return
      }

      const common = {
        hide: true,
        css_style: {
          '--back-opacity': 0.95,
          '--clr-back': 'var(--clr-blue-1)',
          'pointer-events': 'none',
        },
        hideTimeout: 1200,
        // hideTimeout: 999999,
      }

      const getHtmlMessage = ({ title, text, icon }) => `
        <div class="f-center">
       ${icon ? `<i class="mdi ${icon} text-large mr-4" style="line-height:0"></i>` : ''}
        <span class="weight_500 text-normal">${title}</span>
        ${text ? `<span class="clr-grey ml-4">${text}</span>` : ''}
        </div>
        `

      const res = [
        {
          id: 'practice_hero_frequency',
          text: getHtmlMessage({
            title: this.$t('practice_hero_frequency.title'),
            text: this.$t('practice_hero_frequency.press_key_toggle', {
              key: hotkeys.practice_hero_frequency.displayCombination,
            }),
          }),
          ...common,
        },
        {
          id: 'focus',
          text: getHtmlMessage({
            title: this.$t('focus_mode.title'),
            text: this.$t('focus_mode.press_key_exit', {
              key: hotkeys.focus_mode.displayCombination,
            }),
            icon: 'mdi-image-filter-center-focus',
          }),
          ...common,
        },
        {
          id: 'grouping',
          text: getHtmlMessage({
            title: this.$t('actions_grouping.title'),
            text: this.$t('actions_grouping.press_key_to_switch', {
              key: hotkeys.switch_actions_grouping.displayCombination,
            }),
          }),
          ...common,
        },
        {
          id: 'show_bets_in',
          text: getHtmlMessage({
            title: this.$t('switch_pot_bb.title'),
            text: this.$t('switch_pot_bb.press_key_to_switch', {
              key: hotkeys.switch_pot_bb.displayCombination,
            }),
          }),
          ...common,
        },
        {
          id: 'show_ev_in',
          text: getHtmlMessage({
            title: this.$t('switch_ev_pot_tra01.title'),
            text: this.$t('switch_ev_pot_tra01.press_key_to_switch', {
              key: hotkeys.switch_ev_pot.displayCombination,
            }),
          }),
          ...common,
        },
        {
          id: 'gmf_change',
          text: getHtmlMessage({
            title: this.$t('gmf_change.title'),
            text: this.$t('gmf_change.press_key_to_switch', {
              key: this.$t('common.arrow_up_down'),
            }),
          }),
          ...common,
        },
        {
          id: 'training_plan_step_finished',
          text: getHtmlMessage({
            title: this.$t('study_plans.step_finished'),
            icon: 'mdi-checkbox-marked-circle clr-primary',
          }),
          ...common,
          css_style: {
            ...common.css_style,
            '--clr-back': 'var(--clr-primary-1)',
          },
        },
      ].find(i => i.id === id)
      if (res) {
        // console.log(res)
        this.$store.dispatch('messages', res)
        return
      }
      console.warn('!!! no such prompt ID', { id })
    },
  },
}

export default prompt_mix
